import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';
import { buildNaturalGasNarrativeTokens } from './naturalGasNarrativeTokens';

export type NaturalGasViewId = 'total' | 'res' | 'com' | 'perCapita';

export type NaturalGasProvenanceStatus =
  | 'NEEDS_SOURCE_VERIFICATION'
  | 'partial_metadata'
  | 'ghg_inventory_state'
  | 'format_table_pipeline';

export interface NaturalGasNarrativeInput {
  locationName: string;
  viewId: NaturalGasViewId;
  latestYear: number | null;
  baselineYear: number;
  totalTherms: number | null;
  residentialTherms: number | null;
  commercialTherms: number | null;
  percentChange: number | null;
  residentialShare: number | null;
  commercialShare: number | null;
  localThermsPerPerson: number | null;
  californiaThermsPerPerson: number | null;
  comparisonYear?: number | null;
  comparisonCompatibility?: 'compatible' | 'none';
  hasEstimatedYears: boolean;
  activeResidentialModel?: string;
  activeCommercialModel?: string;
  provenanceStatus: NaturalGasProvenanceStatus;
  sourceAgency?: string | null;
  sourceDataset?: string | null;
  sourceVintage?: string | null;
  gasMethodologyDataSources?: string[];
}

const CHART_ID = 'natural_gas_consumption';

export function buildNaturalGasNarrativeFacts(input: NaturalGasNarrativeInput) {
  return {
    locationName: input.locationName,
    viewId: input.viewId,
    latestYear: input.latestYear,
    baselineYear: input.baselineYear,
    percentChange: input.percentChange,
    residentialShare: input.residentialShare,
    commercialShare: input.commercialShare,
    provenanceStatus: input.provenanceStatus,
  };
}

export function buildNaturalGasAuthoredBundle(input: NaturalGasNarrativeInput) {
  const tokens = buildNaturalGasNarrativeTokens(input);
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, input.viewId, tokens);
  const provenanceVerified = input.provenanceStatus === 'format_table_pipeline' && input.sourceDataset;
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus) || !provenanceVerified) {
    bundle.methodology = undefined;
  }
  return bundle;
}

export function buildNaturalGasOverviewDescription(
  viewId: NaturalGasViewId,
  fallback: string
): string {
  return getAuthoredOverview(CHART_ID, viewId, fallback);
}

export function buildNaturalGasKeyInsights(input: NaturalGasNarrativeInput): string {
  const bundle = buildNaturalGasAuthoredBundle(input);
  if (bundle.keyInsights) return bundle.keyInsights;
  return '';
}
